module.exports = __webpack_public_path__ + "static/media/test-croc.097fa81b.jpg";